import { render } from "./recordList.vue?vue&type=template&id=701f263e&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"

import "./recordList.vue?vue&type=style&index=0&id=701f263e&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701f263e"],['__file',"src/views/alfmeier/quest/recordList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "701f263e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('701f263e', __exports__)) {
    console.log('reload')
    api.reload('701f263e', __exports__)
  }
  
  module.hot.accept("./recordList.vue?vue&type=template&id=701f263e&scoped=true", () => {
    console.log('re-render')
    api.rerender('701f263e', render)
  })

}


export default __exports__